import { useContext, useState } from 'react';
import { Card, Container, Grid } from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import IconButton from 'src/components/Button/IconButton';
import DownloadIcon from '@mui/icons-material/Download';
import { ActionContext } from 'src/contexts/ActionContext';
import MOCK_ROUTES from 'src/data/DATA_ROUTES.json';
import ASMBreadcrumb from 'src/components/Breadcrumbs';
import EditIcon from '@mui/icons-material/Edit';
import SaveIcon from '@mui/icons-material/Save';
import CancelIcon from '@mui/icons-material/Cancel';
import { useTranslation } from 'react-i18next';
import { eaService } from 'src/services';
import SuspenseLoader from 'src/components/SuspenseLoader';
import { base64ToArrayBuffer } from 'src/utils/utils';
import ASMAlert from 'src/components/Alert';
import { BusinessManagerContext } from 'src/contexts/BusinessManagerContext';
import html2canvas from "html2canvas";
import { User } from 'src/models/user/user.model';
import { CURRENT_USER } from 'src/constants';
import { useParams } from 'react-router-dom';

function HeaderFicheEEPBM(props) {
    const { REACT_APP_NOTIFICATION_DURATION } = process.env;
    const userData: User = JSON.parse(localStorage.getItem(CURRENT_USER));
    const routes = MOCK_ROUTES[32].routes;
    const [loading, setLoading] = useState(false);
    const [displayAlertError, setDisplayAlertError] = useState(false);

    const {
        isUserHimSelf,
        actionToggle,
        toggleAction
    } = useContext(ActionContext);

    const {
        chartData
    } = useContext(BusinessManagerContext);
    const { idBusinessManagerContext } = useContext(BusinessManagerContext);

    const { t, i18n } = useTranslation();
    const data = {
        id: props.data.id,
        idUser: props.data.idUser,
        reference: props.data.reference,
        fullName: props.data.fullName,
        title: props.data.title,
        year: props.data.year,
        idStatus: props.data.idStatus,
        status: props.data.status
    };
    const cannotModif = props.data.idStatus > 2 && isUserHimSelf;
    const idLang = i18n.language === 'fr' ? 1 : 2;
    const params = useParams();
    let request = {
        idUser: params.id != undefined ? parseInt(params.id) : userData.id,
        year: params.year,
        idLang: idLang,
        idBusinessManager: idBusinessManagerContext
    };

    const ViewFile = async () => {
        setLoading(true);
        props.handleClickSaveEepBM(true, false, false, !actionToggle);
        const formData = new FormData();
        if (chartData) {
            const canvas = await html2canvas(chartData);
            canvas.toBlob(async (blob) => {
                if (blob) {
                    formData.append("file", blob);
                    await eaService.downLoadEEPBM(formData, request).then(response => {
                        if (response.data.success) {
                            var sampleArr = base64ToArrayBuffer(response.data.data.pdf);
                            var blob = new Blob([sampleArr], { type: "application/pdf" });
                            var link = document.createElement('a');
                            link.href = window.URL.createObjectURL(blob);
                            link.target = '_blank';
                            link.click();
                        }
                        else {
                            setDisplayAlertError(true);
                            setTimeout(() => {
                                setDisplayAlertError(false);
                            }, parseInt(REACT_APP_NOTIFICATION_DURATION) * 1000);
                        }

                    }).catch(err => {
                        setDisplayAlertError(true);
                        setTimeout(() => {
                            setDisplayAlertError(false);
                        }, parseInt(REACT_APP_NOTIFICATION_DURATION) * 1000);
                    }).finally(() => {
                        setLoading(false);
                    });
                }
            }, "image/png");
        }
    }

    const DownloadFile = async () => {
        setLoading(true);
        props.handleClickSaveEepBM(true, false, false, !actionToggle);
        const formData = new FormData();
        if (chartData) {
            const canvas = await html2canvas(chartData);
            canvas.toBlob(async (blob) => {
                if (blob) {
                    formData.append("file", blob);
                    await eaService.downLoadEEPBM(formData, request).then(response => {
                        if (response.data.success) {
                            var sampleArr = base64ToArrayBuffer(response.data.data.word);
                            var blob = new Blob([sampleArr], { type: "application/msword" });
                            var fileName = response.data.data.nameFile;
                            var link = document.createElement('a');
                            link.href = window.URL.createObjectURL(blob);
                            link.download = fileName;
                            link.click();
                        }
                        else {
                            setDisplayAlertError(true);
                            setTimeout(() => {
                                setDisplayAlertError(false);
                            }, parseInt(REACT_APP_NOTIFICATION_DURATION) * 1000);
                        }

                    }).catch(err => {
                        setDisplayAlertError(true);
                        setTimeout(() => {
                            setDisplayAlertError(false);
                        }, parseInt(REACT_APP_NOTIFICATION_DURATION) * 1000);
                    }).finally(() => {
                        setLoading(false);
                    });
                }
            }, "image/png");
        }
    }

    const renderButtons = () => {
        if (actionToggle) {
            return (
                <>
                    <IconButton
                        variant="contained"
                        color="primary"
                        title={t('button.save')}
                        margin={5}
                        width={36.5}
                        onClick={props.handleClickSaveEepBM}
                        icon={<SaveIcon style={{ fontSize: 20 }} />}
                        disabled={cannotModif}
                    />
                    <IconButton
                        variant="contained"
                        color="error"
                        title={t('button.cancel')}
                        margin={5}
                        width={36.5}
                        onClick={props.cancel}
                        icon={<CancelIcon style={{ fontSize: 20 }} />}
                        disabled={cannotModif}
                    />
                </>
            );
        } else {
            return (
                <>
                    <IconButton
                        variant="contained"
                        color="primary"
                        title={t('button.edit')}
                        margin={5}
                        width={36.5}
                        icon={<EditIcon style={{ fontSize: 20 }} />}
                        onClick={toggleAction}
                        disabled={cannotModif}
                    />
                </>
            );
        }


    };

    return (
        <>
            {loading && (
                <>
                    <SuspenseLoader />
                </>
            )}
            <ASMAlert message={t('action.error')} severity="error" open={displayAlertError} />
            <Grid container direction="row" maxWidth="lg"
                style={{
                    backgroundColor: '#f2f5f9', minHeight: 32, position: 'sticky', zIndex: 5, top: 60, padding: '5px 24px'
                }}>
                <ASMBreadcrumb links={routes} />
            </Grid>
            <Container maxWidth="lg" style={{ position: 'sticky', zIndex: 4, top: 104, paddingBottom: 10 }}>
                <Card>
                    <Grid
                        container
                        direction="row"
                        alignItems="stretch"
                        style={{ marginTop: 5, paddingLeft: 32, paddingRight: 32 }}
                    >
                        <Grid item xs={4}>
                            <h3 style={{ marginBottom: 10, textOverflow: 'ellipsis', width: '95%', overflow: 'hidden' }}>
                                {data.reference}
                                &nbsp;&nbsp;
                                {data.fullName}
                            </h3>
                        </Grid>
                        <Grid item xs={3}>
                            <h3 style={{ textOverflow: 'ellipsis', overflow: 'hidden' }}>
                                {data.title}
                            </h3>
                        </Grid>
                        <Grid item xs={1}><h3>{data.year}</h3></Grid>
                        <Grid item xs={1}><h3 style={{ textAlign: 'right' }}><span style={{ color: '#00b0be' }} >{data.status}</span></h3></Grid>
                        <Grid item xs={3} style={{ textAlign: 'right' }}>
                            <h3 style={{ marginTop: 10 }}>
                                <IconButton
                                    variant="contained"
                                    color="secondary"
                                    width={36.5}
                                    icon={<VisibilityIcon style={{ fontSize: 20 }} />}
                                    onClick={ViewFile}
                                />
                                <IconButton
                                    variant="contained"
                                    color="secondary"
                                    margin={5}
                                    width={36.5}
                                    icon={<DownloadIcon style={{ fontSize: 20 }} />}
                                    onClick={DownloadFile}
                                />
                                {renderButtons()}
                            </h3>
                        </Grid>
                    </Grid>
                </Card>
            </Container>
        </>
    );
}

export default HeaderFicheEEPBM;